export function asyncLoadJs(url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    document.body.appendChild(script);
    script.onload = () => {
      resolve();
    };
    script.onerror = () => {
      reject();
    };
  });
}

export function loadCanvas() {
  return new Promise((resolve, reject) => {
    asyncLoadJs('static/vendor/canvas/canvas.js')
      .then(() => {
        resolve();
      })
      .catch(err => {
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/utils/asyncLoad.js